import { useStaticPageStyles } from "apps/project-iq/pages/staticPageStyles";
import { WorkspacePageHeader } from "apps/project-iq/components/WorkspacePageHeader/WorkspacePageHeader";
import { useGroupedWorkspaceDashboardStyles } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.styles";
import { IGroupedWorkspaceDashboardProps } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.types";
import { WorkspaceGroupRow } from "apps/project-iq/components/GroupedWorkspaceDashboard/WorkspaceGroupRow";
import { GroupedWorkspaceDashboardSkeleton } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboardSkeleton";

export const GroupedWorkspaceDashboard = ({
  pageTitle,
  pageDescription,
  isAccessLoading,
  isAccessCheckError,
  accessCheckErrorMessage,
  hasAccess,
  accessDeniedMessage,
  isDataLoading,
  isDataError,
  dataErrorMessage,
  groups,
  emptyStateMessage,
}: IGroupedWorkspaceDashboardProps): JSX.Element => {
  const staticStyles = useStaticPageStyles();
  const styles = useGroupedWorkspaceDashboardStyles();

  const getContent = (): JSX.Element => {
    if (isAccessLoading) {
      return <GroupedWorkspaceDashboardSkeleton />;
    }
    if (isAccessCheckError) {
      return <div className={staticStyles.card}>{accessCheckErrorMessage}</div>;
    }
    if (!hasAccess) {
      return <div className={staticStyles.card}>{accessDeniedMessage}</div>;
    }
    if (isDataLoading) {
      return <GroupedWorkspaceDashboardSkeleton />;
    }
    if (isDataError) {
      return <div className={staticStyles.card}>{dataErrorMessage}</div>;
    }
    if (groups.length === 0) {
      return <div className={staticStyles.card}>{emptyStateMessage}</div>;
    }
    return (
      <div className={styles.groupList}>
        {groups.map((workspaceGroup) => (
          <WorkspaceGroupRow
            key={workspaceGroup.group.id}
            group={workspaceGroup}
          />
        ))}
      </div>
    );
  };

  const content = getContent();

  return (
    <>
      <WorkspacePageHeader title={pageTitle} />
      <div className={styles.pageBody}>
        <div className={styles.pageContent}>
          <p className={staticStyles.description}>{pageDescription}</p>
          {content}
        </div>
      </div>
    </>
  );
};
